import axios from 'axios';
import Vue from 'vue';

axios.interceptors.request.use(
  config => {
	if(Vue.prototype.ssoSikp === 'false'){
		config.headers.Authentication = Vue.prototype.token;
	}
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
	//console.log('response:{}',response.data.code);
	let status = response.data.code;
	  let message = response.data.message;
	if(Vue.prototype.ssoSikp === 'false'){
		if(status === '10001'||status === '10002'||status === '10003' || message=== 'token不合法' || status === '10004'||status === '10005'||status === '10006'||status === '10007'||status === '10008'||status === '10009'||status === '10010'||status === '10011'||status === '10012'){
			Vue.prototype.setToken('')
			//window.location.href = 'https://federation-qa.corpnet4.com/as/authorization.oauth2?client_id=166dc5399942457a8eff18b68c9607b8&response_type=code';
			window.location.href = Vue.prototype.ssoconfig;
		}
	}
    return response;
  },
  error => {
	//let flag = flags.flag;
	//let switchFlag = localStorage.getItem('ssoswitch');
	//console.log('error:{}',error.response);
	//let status = error.response.data.status;
	//console.log('error:',error);
	//if(switchFlag == 'true'){
    // 对响应错误做一些处理
		//if(status === 10001){
			//window.location.href = 'https://federation-qa.corpnet4.com/as/authorization.oauth2?client_id=166dc5399942457a8eff18b68c9607b8&response_type=code';
			//window.location.href = localStorage.getItem('ssoconfig');
		//}
	//}
	return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/libs/axiosInterceptor.js